import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Block } from '../../abstract/Block.js';
export class ProgressBar extends Block {
  constructor() {
    super(...arguments);
    /** @type {Number} */
    _defineProperty(this, "_value", 0);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      width: 0,
      opacity: 0
    }));
  }
  initCallback() {
    super.initCallback();
    this.defineAccessor('value', value => {
      if (value === undefined) {
        return;
      }
      const prevValue = this._value;
      this._value = value;
      if (value === 0 && prevValue > 0) {
        this.ref.line.addEventListener('transitionend', () => {
          this.style.setProperty('--l-width', this._value.toString());
        });
        return;
      }
      this.style.setProperty('--l-width', this._value.toString());
    });
    this.defineAccessor('visible', visible => {
      this.ref.line.classList.toggle('progress--hidden', !visible);
    });
  }
}
ProgressBar.template = /* HTML */" <div ref=\"line\" class=\"progress\"></div> ";